/*!
 *  - shop.js
 * @generated Thu Dec 15 2022 16:27:58 GMT+0900 (GMT+09:00)
 */
'use strict';

(function ($, FUNCTIONS) {
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-fixed';
	var slideSpeed = '400';

	// ＜共通＞JSON取得 ---------------------------------------------------
	// お気に入りリスト描画用
	var getJSONstore = function getJSONstore(_id) {
		return $.getJSON('/ajax/store/store/' + _id + '.json');
	};
	// 県名一覧
	var getJSONprefecture = function getJSONprefecture() {
		return $.getJSON('/ajax/shop/prefecture.json');
	};
	// 市区郡一覧
	var getJSONcity = function getJSONcity(_id) {
		return $.getJSON('/ajax/flyer/city/' + _id + '.json');
	};
	// ブランドチェックボックス設置用
	var getJSONbrand = function getJSONbrand() {
		return $.getJSON('/ajax/store/brand.json');
	};
	// ＜共通＞----------------------------------------------------

	var pickupFixed = function pickupFixed() {
		if ($('.shop-index').length) {
			var pickup = $('.js-shop-index-pickup');
			var main = $('.js-shop-index-main');

			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var mainPos = main.offset().top;
				var thisScroll = $this.scrollTop();

				if (FUNCTIONS.va.window.width < 1025) {
					mainPos -= 60;
				} else {
					mainPos -= 68;
				}

				if (thisScroll > mainPos) {
					pickup.addClass(f);
				} else {
					pickup.removeClass(f);
				}
			});
		}
	};
	// 現在地から探すボタン
	var searchLocation = function searchLocation() {
		$('.js-search-btn-location').on('click', function () {
			var getPosSuccess = function getPosSuccess(pos) {
				location.href = '/shop/search/list_point.html?p_lat=' + pos.coords.latitude + '&p_lon=' + pos.coords.longitude + '&p_max=30000';
			};
			var getPosError = function getPosError() {
				alert('位置情報を取得できませんでした。');
				location.href = '/shop/search/list_point.html?p_lat=35.589223&p_lon=139.732176&p_max=30000';
			};
			navigator.geolocation.getCurrentPosition(getPosSuccess, getPosError);
		});
	};
	// キーワード検索
	var searchKeyword = function searchKeyword() {
		var btn = $('.js-keyword-btn');
		var input = $('.js-keyword-input');
		var clear = $('.js-keyword-clear');
		var urlParam = location.search.substring(1);
		var i = void 0;
		if (urlParam) {
			var param = urlParam.split('&');
			var paramArray = [];
			for (i = 0; i < param.length; i++) {
				var paramItem = param[i].split('=');
				paramArray[paramItem[0]] = paramItem[1];
			}
			if (paramArray.keyword) {
				input.val(decodeURI(paramArray.keyword));
			}
		}
		btn.on('click', function () {
			if (!input.val()) {
				alert('キーワードを入力してください。');
			} else {
				window.location.href = '/shop/search/list.html?keyword=' + encodeURI(input.val());
			}
		});
		input.keypress(function (e) {
			if (e.which === 13) {
				if (!input.val()) {
					alert('キーワードを入力してください。');
				} else {
					window.location.href = '/shop/search/list.html?keyword=' + encodeURI(input.val());
				}
				return false;
			}
		});
		clear.on('click', function () {
			input.val('');
		});
	};
	// 詳細検索
	var formsubmit = function formsubmit() {
		var submitBtn = $('.js-shop-form-submit');
		var clearBtn = $('.js-shop-form-clear');
		var shopForm = $('.js-shop-form');
		var prefectureSelect = $('.js-shop-form-prefecture');
		var citySelect = $('.js-shop-form-city');
		var searchcity = function searchcity(_prefectureSelectVal) {
			prefectureSelect.css('pointer-events', 'none');
			citySelect.css('pointer-events', 'none');
			$('.js-shop-form-city option').remove();
			citySelect.append($('<option>').html('選択してください').val(''));
			getJSONcity(_prefectureSelectVal).done(function (data) {
				// パラメータ格納
				var urlParam = location.search.substring(1);
				var paramArray = [];
				if (urlParam) {
					var param = urlParam.split('&');
					for (var i = 0; i < param.length; i++) {
						var paramItem = param[i].split('=');
						paramArray[paramItem[0]] = paramItem[1];
					}
				}
				// リストから重複を削除
				var list = data.rt_bn_store_list;
				var clearList = list.filter(function (v1, i1, a1) {
					return a1.findIndex(function (v2) {
						return v1.cf_s_city === v2.cf_s_city;
					}) === i1;
				});
				// optionセット
				for (var _i = 0; _i < clearList.length; _i++) {
					// デコードしたp_cityと一致すればセレクト
					if (decodeURI(paramArray.p_city) === clearList[_i].cf_s_city) {
						citySelect.append($('<option>').html(clearList[_i].cf_s_city).val(clearList[_i].cf_s_city).prop('selected', true));
					} else {
						citySelect.append($('<option>').html(clearList[_i].cf_s_city).val(clearList[_i].cf_s_city));
					}
				}
				prefectureSelect.css('pointer-events', 'auto');
				citySelect.css('pointer-events', 'auto');
			});
		};
		// 県名表示
		prefectureSelect.css('pointer-events', 'none');
		citySelect.css('pointer-events', 'none');
		$('.js-shop-form-prefecture option').remove();
		prefectureSelect.append($('<option>').html('選択してください').val(''));
		getJSONprefecture().done(function (data) {
			// リストから重複を削除
			var list = data.rt_bn_store_list;
			var clearList = list.filter(function (v1, i1, a1) {
				return a1.findIndex(function (v2) {
					return v1.cf_s_prefecture === v2.cf_s_prefecture;
				}) === i1;
			});
			// optionセット
			for (var i = 0; i < clearList.length; i++) {
				if (!(location.pathname.split('/')[3] === 'list_point.html')) {
					if (!(location.pathname.split('/')[3] === 'list.html')) {
						if (clearList[i].cf_s_prefecture_code === location.pathname.split('/')[3]) {
							prefectureSelect.append($('<option>').html(clearList[i].cf_s_prefecture).val(clearList[i].cf_s_prefecture_code).prop('selected', true));
						} else {
							prefectureSelect.append($('<option>').html(clearList[i].cf_s_prefecture).val(clearList[i].cf_s_prefecture_code));
						}
					} else {
						prefectureSelect.append($('<option>').html(clearList[i].cf_s_prefecture).val(clearList[i].cf_s_prefecture_code));
					}
				} else {
					prefectureSelect.append($('<option>').html(clearList[i].cf_s_prefecture).val(clearList[i].cf_s_prefecture_code));
				}
			}
			prefectureSelect.css('pointer-events', 'auto');
			citySelect.css('pointer-events', 'auto');
		});
		if (!(location.pathname.split('/')[2] === '')) {
			if (!(location.pathname.split('/')[2] === 'index.html')) {
				if (!(location.pathname.split('/')[3] === 'list_point.html')) {
					if (!(location.pathname.split('/')[3] === 'list.html')) {
						// 一覧ページcityカレント
						var prefectureSelectJSON = location.pathname.split('/')[3];
						searchcity(prefectureSelectJSON);
					}
				}
			}
		}
		// submit
		submitBtn.on('click', function () {
			if (prefectureSelect.val()) {
				if (!$('input[name="p_brand"]:checked').val()) {
					shopForm.attr('action', '/shop/search/' + prefectureSelect.val() + '/');
					shopForm.submit();
				} else {
					shopForm.attr('action', '/shop/search/' + prefectureSelect.val() + '/');
					shopForm.submit();
				}
			} else {
				alert('都道府県を選択してください。');
			}
		});
		clearBtn.on('click', function () {
			shopForm.find('textarea, :text, select').val('').end().find(':checked').prop('checked', false);
		});
		// 市区郡一覧
		prefectureSelect.change(function () {
			// 県名が入っている場合
			if (prefectureSelect.val()) {
				searchcity(prefectureSelect.val());
			}
		});
		citySelect.on('click', function () {
			if (!prefectureSelect.val()) {
				alert('都道府県を選択してください');
			}
		});
	};
	// お気に入りリスト描画
	var addFavList = function addFavList() {
		if ($('.js-shop-index-list').length) {
			var addBlock = $('.js-shop-index-list'),
			    i = void 0,
			    l = void 0;
			var favoStorage = [];
			var favArr = [];

			for (i in localStorage) {
				if (i.indexOf('favItem-') !== -1) {
					favoStorage.push(i);
				}
			}
			for (i = 0; i < favoStorage.length; i++) {
				var hash = {
					name: favoStorage[i],
					datetime: localStorage[favoStorage[i]]
				};
				favArr.push(hash);
			}
			// itemArray配列に、jsonの内容を格納
			var itemArray = [];
			var favItemList = new Promise(function (resolve) {
				var items = void 0;
				var count = 0;
				for (i = 0; i < favArr.length; i++) {
					getJSONstore(favArr[i].name.replace('favItem-', '')).then(function (data) {
						console.log(data, 'data');
						items = {
							id: data.rt_bn_store[0]._key,
							brandKey: data.rt_bn_store[0].cf_s_brand._key,
							brandName: data.rt_bn_store[0].cf_s_brand.cf_sb_name,
							storeUrl: data.rt_bn_store[0].rt_cf_s_url.href,
							storeName: data.rt_bn_store[0].cf_s_shop_name,
							storePrefecture: data.rt_bn_store[0].cf_s_prefecture,
							storeCity: data.rt_bn_store[0].cf_s_city,
							storeAddress1: data.rt_bn_store[0].cf_s_address1,
							storeAddress2: data.rt_bn_store[0].cf_s_address2,
							googlemapurl: data.rt_bn_store[0].rt_google_maps_url.href,
							pickupUrl: data.rt_bn_store[0].rt_flyer_url.href
						};
						itemArray.push(items);
						count++;
						if (count === favArr.length) {
							return resolve(itemArray);
						}
					});
				}
			});
			Promise.all([favItemList]).then(function () {
				// itemArray配列に時間を追加
				for (i = 0; i < favArr.length; i++) {
					for (l = 0; l < itemArray.length; l++) {
						if (favArr[i].name === 'favItem-' + itemArray[l].id) {
							itemArray[l].datatime = favArr[i].datetime;
						}
					}
				}
				// 降順ソート
				itemArray.sort(function (sorta, sortb) {
					return sorta.datatime < sortb.datatime ? 1 : -1;
				});
				// 描画
				for (i = 0; i < favArr.length; i++) {
					var mapUrl = itemArray[i].googlemapurl;
					var shopLinkArea = void 0,
					    shopLinkBtnArea = void 0;
					if (itemArray[i].storeUrl.indexOf('https') !== -1) {
						shopLinkArea = '<a href="' + itemArray[i].storeUrl + '" class="shop-favList-title-name" target="_blank">';
						shopLinkBtnArea = '<a href="' + itemArray[i].storeUrl + '" class="js-shop-list-item-link mod-btn mod-btn_left" target="_blank"><i class="icon icon-webchirashi"></i>店舗情報</a>';
					} else {
						shopLinkArea = '<a href="' + itemArray[i].storeUrl + '" class="shop-favList-title-name">';
						shopLinkBtnArea = '<a href="' + itemArray[i].storeUrl + '" class="js-shop-list-item-link mod-btn mod-btn_left"><i class="icon icon-webchirashi"></i>店舗情報</a>';
					}

					if (itemArray[i].storeName === 'ペットエキスポ 瀬戸店') {
						mapUrl = 'https://www.google.com/maps?q=愛知県瀬戸市西原町２丁目+68番地+DCMカーマ+21+瀬戸店';
						// console.log("1");
					}
					if (itemArray[i].storeName === 'ペットエキスポ 可児店') {
						mapUrl = 'https://www.google.com/maps?q=岐阜県可児市下恵土+字広瀬+5845番地DCMカーマ+可児店';
						// console.log("2");
					}
					if (itemArray[i].storeName === 'ペットエキスポ 稲沢店') {
						mapUrl = 'https://www.google.com/maps?q=愛知県稲沢市陸田宮前１丁目１−１+DCMカーマ+21稲沢店';
						// console.log("3");
					}
					if (itemArray[i].storeName === 'ペットエキスポ 豊川正岡店') {
						mapUrl = 'https://www.google.com/maps?q=愛知県豊川市正岡町池田７０６−１+DCMカーマ豊川正岡店';
						// console.log("4");
					}
					if (itemArray[i].storeName === 'ペットエキスポ 豊橋汐田橋店') {
						mapUrl = 'https://www.google.com/maps?q=愛知県豊橋市牟呂町扇田２１−３+DCMカーマ+21豊橋汐田橋店';
						// console.log("5");
					}
					if (itemArray[i].storeName === 'ペットエキスポ 豊橋南店') {
						mapUrl = 'https://www.google.com/maps?q=愛知県豊橋市大清水町大清水３−１１８０+DCMカーマ+21豊橋南店';
						// console.log("6");
					}
					if (itemArray[i].storeName === 'ペットエキスポ 西尾店') {
						mapUrl = 'https://www.google.com/maps?q=愛知県西尾市丁田町杢左２８+DCMカーマ+西尾店';
						// console.log("7");
					}
					if (itemArray[i].storeName === 'ペットエキスポ 安城住吉店') {
						mapUrl = 'https://www.google.com/maps?q=愛知県安城市住吉町３丁目１２−12番3号+DCMカーマ+安城住吉店';
						// console.log("8");
					}
					if (itemArray[i].storeName === 'ペットエキスポ 熱田店') {
						mapUrl = 'https://www.google.com/maps?q=愛知県名古屋市熱田区花表町２１−2103番1+DCMカーマ+21熱田店';
						// console.log("9");
					}
					if (itemArray[i].storeName === 'ペットエキスポ 瀬戸店') {
						mapUrl = 'https://www.google.com/maps?q=愛知県瀬戸市西原町２丁目68番地+DCMカーマ+21瀬戸店';
						// console.log("10");
					}
					if (itemArray[i].storeName === 'ペットエキスポ恵那店') {
						mapUrl = 'https://www.google.com/maps?q=岐阜県恵那市長島町正家522番地5+DCMカーマ+21恵那店';
						// console.log("11");
					}
					if (itemArray[i].storeName === 'ペットエキスポ 富山本郷店') {
						mapUrl = 'https://www.google.com/maps?q=富山県富山市堀川本郷１６０−１+DCMカーマ+富山本郷店';
						// console.log("12");
					}
					if (i === 0) {
						addBlock.append('<li class="shop-favList-item js-shop-list-item is-visible">' + '<button class="shop-favList-img is-fav">' + '<img src="/images/shop/search/' + itemArray[i].brandKey + '_icon.jpg" class="width-u-100" alt="' + itemArray[i].brandName + '">' + '<i class="icon icon-fav"></i>' + '<p class="di_none"><span class="js-shop-list-item-id">' + itemArray[i].id + '</span></p>' + '</button>' + '<div class="shop-favList-title">' + shopLinkArea +
						// '<span>'+itemArray[i].brandName+'</span> '+
						'<span class="js-shop-list-item-title">' + itemArray[i].storeName + '</span>' + '</a>' + '<p class="shop-favList-title-address"><span class="js-shop-list-item-address"><span>' + itemArray[i].storePrefecture + '</span><span class="rt_cf_s_city">' + itemArray[i].storeCity + '</span><span>' + itemArray[i].storeAddress1 + '</span><span>' + itemArray[i].storeAddress2 + '</span></span></p></div>' + '<div class="shop-favList-btn">' + shopLinkBtnArea + '<a href="' + itemArray[i].pickupUrl + '" class="mod-btn mod-btn_left pl0 mt10" target="_blank">チラシ情報</a>' + '<a href="' + mapUrl + '" class="mod-btn mod-btn_left mt10 pl0" target="_blank">地図・混雑状況を見る</a></div>' + '</li>');
					} else {
						addBlock.append('<li class="shop-favList-item js-shop-list-item">' + '<button class="shop-favList-img is-fav">' + '<img src="/images/shop/search/' + itemArray[i].brandKey + '_icon.jpg" class="width-u-100" alt="' + itemArray[i].brandName + '">' + '<i class="icon icon-fav"></i>' + '<p class="di_none"><span class="js-shop-list-item-id">' + itemArray[i].id + '</span></p>' + '</button>' + '<div class="shop-favList-title">' + shopLinkArea +
						// '<span>'+itemArray[i].brandName+'</span> '+
						'<span class="js-shop-list-item-title">' + itemArray[i].storeName + '</span>' + '</a>' + '<p class="shop-favList-title-address"><span class="js-shop-list-item-address"><span>' + itemArray[i].storePrefecture + '</span><span class="rt_cf_s_city">' + itemArray[i].storeCity + '</span><span>' + itemArray[i].storeAddress1 + '</span><span>' + itemArray[i].storeAddress2 + '</span></span></p></div>' + '<div class="shop-favList-btn">' + shopLinkBtnArea + '<a href="' + itemArray[i].pickupUrl + '" class="mod-btn mod-btn_left pl0 mt10" target="_blank">チラシ情報</a>' + '<a href="' + mapUrl + '" class="mod-btn mod-btn_left mt10 pl0" target="_blank">地図・混雑状況を見る</a></div>' + '</li>');
					}
				}
			});
			// 0ならブロックごと非表示・2以上ならmoreボタン表示
			if (favArr.length) {
				$('.js-shop-index-list-item-wrap').addClass(a);
				if (favArr.length < 2) {
					$('.js-shop-index-list-item-more').remove();
				}
			}
			// 描画後の、お気に入り削除・ブロックごと削除用
			$(function () {
				$('.js-shop-index-list-item-more button').on('click', function () {
					$('.js-shop-list-item').addClass(v);
					$('.js-shop-index-list-item-more').remove();
				});
				$(document).on('click', '.shop-favList-img', function () {
					localStorage.removeItem('favItem-' + $(this).find('.js-shop-list-item-id').text());
					$(this).parents('.shop-favList-item').remove();
					if (!$('.shop-favList-item').length) {
						$('.js-shop-index-list-item-wrap').remove();
					}
				});
			});
		}
	};
	// お気に入りボタン
	var favClick = function favClick() {
		var favBtn = $('.shop-favList-img');
		var prodCode = void 0,
		    i = void 0;
		// すでにお気に入り追加されているitemをアクティブに
		for (i = 0; i < favBtn.length; i++) {
			prodCode = favBtn.eq(i).find('.js-shop-list-item-id').text();
			if (localStorage.getItem('favItem-' + prodCode)) {
				favBtn.eq(i).addClass('is-fav');
			}
		}
		// お気に入り追加・削除
		favBtn.on('click', function () {
			prodCode = $(this).find('.js-shop-list-item-id').text();
			var favoStorageLength = 0;
			for (var _i2 in localStorage) {
				if (_i2.indexOf('favItem-') !== -1) {
					favoStorageLength++;
				}
			}
			if (favoStorageLength < 5) {
				if (!$(this).hasClass('is-fav')) {
					$(this).addClass('is-fav');
					var favoDatetime = new Date();
					localStorage.setItem('favItem-' + prodCode, favoDatetime);
				} else {
					$(this).removeClass('is-fav');
					localStorage.removeItem('favItem-' + prodCode);
				}
			} else {
				if (!$(this).hasClass('is-fav')) {
					alert('お気に入り店舗は5件以上登録できません。');
				} else {
					$(this).removeClass('is-fav');
					localStorage.removeItem('favItem-' + prodCode);
				}
			}
		});
	};
	// ブランドチェックボックス部分
	var brandcheck = function brandcheck() {
		var brandcheckClick = function brandcheckClick(_label, _labelChild) {
			var count = 0;
			for (var i = 0; i < _labelChild.length; i++) {
				if (_labelChild.eq(i).find('input').prop('checked')) {
					count++;
				}
			}
			if (count == _labelChild.length) {
				_label.find('input').prop('checked', true);
			}
			_label.find('input').change(function () {
				if (!_label.find('input').prop('checked')) {
					for (var _i3 = 0; _i3 < _labelChild.length; _i3++) {
						_labelChild.eq(_i3).find('input').prop('checked', false);
					}
				} else {
					for (var _i4 = 0; _i4 < _labelChild.length; _i4++) {
						_labelChild.eq(_i4).find('input').prop('checked', true);
					}
				}
			});
		};
		brandcheckClick($('.js-shop-check-dcm'), $('.js-shop-check-dcm-child'));
		brandcheckClick($('.js-shop-check-kahma'), $('.js-shop-check-kahma-child'));
		brandcheckClick($('.js-shop-check-daiki'), $('.js-shop-check-daiki-child'));
		brandcheckClick($('.js-shop-check-homac'), $('.js-shop-check-homac-child'));
		brandcheckClick($('.js-shop-check-sanwa'), $('.js-shop-check-sanwa-child'));
		brandcheckClick($('.js-shop-check-kuroganeya'), $('.js-shop-check-kuroganeya-child'));
		brandcheckClick($('.js-shop-check-keiyo'), $('.js-shop-check-keiyo-child'));
		brandcheckClick($('.js-shop-check-homac_nicot'), $('.js-shop-check-homac_nicot-child'));
		brandcheckClick($('.js-shop-check-hodaka'), $('.js-shop-check-hodaka-child'));
	};

	pickupFixed();
	searchLocation();
	searchKeyword();
	formsubmit();
	addFavList();
	favClick();
	brandcheck();
})(window.jQuery, window.FUNCTIONS);